var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame89(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.125C9.5 14.2299 9.85558 13.3714 10.4885 12.7385C11.1214 12.1056 11.9799 11.75 12.875 11.75H27.125C28.0201 11.75 28.8785 12.1056 29.5115 12.7385C30.1444 13.3714 30.5 14.2299 30.5 15.125V24.875C30.5 25.7701 30.1444 26.6285 29.5115 27.2615C28.8785 27.8944 28.0201 28.25 27.125 28.25H12.875C11.9799 28.25 11.1214 27.8944 10.4885 27.2615C9.85558 26.6285 9.5 25.7701 9.5 24.875V15.125ZM12.875 13.25C12.3777 13.25 11.9008 13.4475 11.5492 13.7992C11.1975 14.1508 11 14.6277 11 15.125V16.25H29V15.125C29 14.6277 28.8025 14.1508 28.4508 13.7992C28.0992 13.4475 27.6223 13.25 27.125 13.25H12.875ZM11 24.875C11 25.3723 11.1975 25.8492 11.5492 26.2008C11.9008 26.5525 12.3777 26.75 12.875 26.75H27.125C27.6223 26.75 28.0992 26.5525 28.4508 26.2008C28.8025 25.8492 29 25.3723 29 24.875V17.75H11V24.875ZM23.75 22.25H26C26.1989 22.25 26.3897 22.329 26.5303 22.4697C26.671 22.6103 26.75 22.8011 26.75 23C26.75 23.1989 26.671 23.3897 26.5303 23.5303C26.3897 23.671 26.1989 23.75 26 23.75H23.75C23.5511 23.75 23.3603 23.671 23.2197 23.5303C23.079 23.3897 23 23.1989 23 23C23 22.8011 23.079 22.6103 23.2197 22.4697C23.3603 22.329 23.5511 22.25 23.75 22.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame89);
export default __webpack_public_path__ + "static/media/Frame 89.4343fbb981d3c04116e6a0b5f1499bd4.svg";
export { ForwardRef as ReactComponent };